import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-end" }

import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'EditableProjectionQuery',
  emits: {
    'cancelled': null,
    'editModeRequired': null
},
  setup(__props, { emit: __emit }) {

const emit = __emit;

const btnYes = ref(null);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[2] || (_cache[2] = _createElementVNode("p", null, "To make it clearer, this chart is only editable when viewed with no increases added and not being shown in today's money.", -1)),
    _cache[3] || (_cache[3] = _createElementVNode("p", null, "Do you want to switch to this view so you can edit any particular year?", -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        ref_key: "btnYes",
        ref: btnYes,
        type: "button",
        class: "btn btn-primary mb-3",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('editModeRequired')))
      }, "Yes", 512),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary mb-3 ms-2",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('cancelled')))
      }, "No")
    ])
  ], 64))
}
}

})